import color from '../../text/color';

const dark = (params) => color(params);

export default dark;
